export const States = [
  {
    isoCode: 'AL',
    value: 'Alabama',
  },
  {
    isoCode: 'AK',
    value: 'Alaska',
  },
  {
    isoCode: 'AZ',
    value: 'Arizona',
  },
  {
    isoCode: 'AR',
    value: 'Arkansas',
  },
  {
    isoCode: 'CA',
    value: 'California',
  },
  {
    isoCode: 'CO',
    value: 'Colorado',
  },
  {
    isoCode: 'CT',
    value: 'Connecticut',
  },
  {
    isoCode: 'DE',
    value: 'Delaware',
  },
  {
    isoCode: 'DC',
    value: 'District Of Columbia',
  },
  {
    isoCode: 'FL',
    value: 'Florida',
  },
  {
    isoCode: 'GA',
    value: 'Georgia',
  },
  {
    isoCode: 'HI',
    value: 'Hawaii',
  },
  {
    isoCode: 'ID',
    value: 'Idaho',
  },
  {
    isoCode: 'IL',
    value: 'Illinois',
  },
  {
    isoCode: 'IN',
    value: 'Indiana',
  },
  {
    isoCode: 'IA',
    value: 'Iowa',
  },
  {
    isoCode: 'KS',
    value: 'Kansas',
  },
  {
    isoCode: 'KY',
    value: 'Kentucky',
  },
  {
    isoCode: 'LA',
    value: 'Louisiana',
  },
  {
    isoCode: 'ME',
    value: 'Maine',
  },
  {
    isoCode: 'MD',
    value: 'Maryland',
  },
  {
    isoCode: 'MA',
    value: 'Massachusetts',
  },
  {
    isoCode: 'MI',
    value: 'Michigan',
  },
  {
    isoCode: 'MN',
    value: 'Minnesota',
  },
  {
    isoCode: 'MS',
    value: 'Mississippi',
  },
  {
    isoCode: 'MO',
    value: 'Missouri',
  },
  {
    isoCode: 'MT',
    value: 'Montana',
  },
  {
    isoCode: 'NE',
    value: 'Nebraska',
  },
  {
    isoCode: 'NV',
    value: 'Nevada',
  },
  {
    isoCode: 'NH',
    value: 'New Hampshire',
  },
  {
    isoCode: 'NJ',
    value: 'New Jersey',
  },
  {
    isoCode: 'NM',
    value: 'New Mexico',
  },
  {
    isoCode: 'NY',
    value: 'New York',
  },
  {
    isoCode: 'NC',
    value: 'North Carolina',
  },
  {
    isoCode: 'ND',
    value: 'North Dakota',
  },
  {
    isoCode: 'OH',
    value: 'Ohio',
  },
  {
    isoCode: 'OK',
    value: 'Oklahoma',
  },
  {
    isoCode: 'OR',
    value: 'Oregon',
  },
  {
    isoCode: 'PA',
    value: 'Pennsylvania',
  },
  {
    isoCode: 'RI',
    value: 'Rhode Island',
  },
  {
    isoCode: 'SC',
    value: 'South Carolina',
  },
  {
    isoCode: 'SD',
    value: 'South Dakota',
  },
  {
    isoCode: 'TN',
    value: 'Tennessee',
  },
  {
    isoCode: 'TX',
    value: 'Texas',
  },
  {
    isoCode: 'UT',
    value: 'Utah',
  },
  {
    isoCode: 'VT',
    value: 'Vermont',
  },
  {
    isoCode: 'VA',
    value: 'Virginia',
  },
  {
    isoCode: 'WA',
    value: 'Washington',
  },
  {
    isoCode: 'WV',
    value: 'West Virginia',
  },
  {
    isoCode: 'WI',
    value: 'Wisconsin',
  },
  {
    isoCode: 'WY',
    value: 'Wyoming',
  },
];

export const Territories = [
  {
    isoCode: 'AS',
    value: 'American Samoa',
  },
  {
    isoCode: 'GU',
    value: 'Guam',
  },
  {
    isoCode: 'MP',
    value: 'Northern Mariana Islands',
  },
  {
    isoCode: 'PR',
    value: 'Puerto Rico',
  },
  {
    isoCode: 'UM',
    value: 'United States Minor Outlying Islands',
  },
  {
    isoCode: 'VI',
    value: 'Virgin Islands',
  },
];

export const ArmedForces = [
  {
    isoCode: 'AA',
    value: 'Armed Forces Americas',
  },
  {
    isoCode: 'AP',
    value: 'Armed Forces Pacific',
  },
  {
    isoCode: 'AE',
    value: 'Armed Forces Others',
  },
];

export const StatesTerritoriesArmedForces = [
  ...States,
  ...Territories,
  ...ArmedForces,
];

export const StatesTerritories = [...States, ...Territories];

export const SupportedStatesTerritoriesArmedForces = [
  ...States,
  {
    isoCode: 'AS',
    value: 'American Samoa',
  },
  {
    isoCode: 'GU',
    value: 'Guam',
  },
  {
    isoCode: 'PR',
    value: 'Puerto Rico',
  },
  {
    isoCode: 'VI',
    value: 'Virgin Islands',
  },
  ...ArmedForces,
];
